module.exports = __webpack_public_path__ + "static/media/paradise_left.25b75603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/paradise_left.jpg
// module id = 598
// module chunks = 0